<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1654_1788)">
      <path
        d="M7.99967 14.6668C4.31767 14.6668 1.33301 11.6822 1.33301 8.00016C1.33301 4.31816 4.31767 1.3335 7.99967 1.3335C11.6817 1.3335 14.6663 4.31816 14.6663 8.00016C14.6663 11.6822 11.6817 14.6668 7.99967 14.6668ZM7.22901 10.9902L11.9423 6.27616L10.9997 5.3335L7.22901 9.10483L5.34301 7.21883L4.40034 8.1615L7.22901 10.9902Z"
        fill="#5BC676"
      />
    </g>
    <defs>
      <clipPath id="clip0_1654_1788">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
